import { render } from "./sponsors.vue?vue&type=template&id=71dbc69a&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=71dbc69a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71dbc69a"

export default script